module.exports = __webpack_public_path__ + "img/index01.e8a4f7b9.svg";